
import { Component, Vue } from 'vue-property-decorator';
import { iAreaDistibute } from '@/interface/area-distribute';
import { getAreaUser } from '@/api/area-distribute';
import LogUtils from 'panda-log';

@Component
export default class AreaDistri extends Vue {
  private areaList: iAreaDistibute[] = [];
  private loading = false;
  private localtime = new Date();

  public async getAreaNums() {
    try {
      this.loading = true;
      const res = await getAreaUser();
      this.areaList = res.data;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.getAreaNums();
  }
}
